<ng-container [ngSwitch]="currentMethod">
	<ng-container *ngSwitchCase="IdentityVerificationMethod.IDVerse">
		<ifc-id-verse-content [advisorData]="advisorData" (verified)="onVerified($event)" (failedNoRetry)="onIdVerseFailedNoRetry($event)"></ifc-id-verse-content>
	</ng-container>
	<ng-container *ngSwitchCase="IdentityVerificationMethod.KBA">
		<ifm-kba-form (verified)="onVerified($event)"></ifm-kba-form>
	</ng-container>
</ng-container>